import { RootState } from 'store';
import { useSelector } from 'react-redux';
import { STATE } from '../types';

export const useLocale = () =>
  useSelector((state: RootState) => state[STATE].i18n.locale);
